import { BrokersContext } from 'contexts/Brokers/Brokers';
import Analytics from 'helpers/analytics';
import { useContext } from 'react';
import { FileType } from 'Views/Files/Files.type';
import { StyledA } from './DocumentName.styles';

type DocumentNameProps = {
	file: FileType;
};

export const DocumentName = ({ file }: DocumentNameProps): JSX.Element => {
	const { isBroker } = useContext(BrokersContext);

	const handleTrackClick = () => {
		Analytics.track('app', 'Open Document', {
			isBroker,
			document: {
				name: file.name,
				type: file.type,
				url: file.url,
			},
		});
	};

	return (
		<StyledA
			href={file.url}
			target="_blank"
			rel="noreferrer"
			onClick={handleTrackClick}
		>
			{file.name}
		</StyledA>
	);
};
